<template>
  <div>
    <!-- v-loading="loading" :element-loading-text="loadingText" -->
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">{{ statusName }}</div>
        <el-form
          class="zj-search-form clear"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="企业名称">
            <el-input
              v-model="companyName"
              style="width: 35rem"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="等级"
            v-if="Status == 1 || Status == 4 || Status == 5"
          >
            <el-select
              v-model="level"
              placeholder="请选择"
              style="width: 35rem"
            >
              <el-option>请选择</el-option>
              <el-option
                v-for="item in options"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label
            class="right"
          >
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <!-- <zj-layout-main style="padding-top:0px;" v-loading="searching" element-loading-text="搜索中"> -->
      <zj-layout-main style="padding-top: 0px">
        <zj-layout-container>
          <zj-layout-header>
            <div class="zj-button-bar">
              <el-button
                size="mini"
                @click="onAdd"
              >添 加</el-button>
            </div>
          </zj-layout-header>
          <zj-layout-main style="padding: 0.8rem 0px 0px 0px">
            <el-table
              class="table-default"
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              height="100%"
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="Name"
                label="企业名称"
              ></el-table-column>
              <el-table-column
                prop="CompanyType"
                label="企业类型"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="Address"
                label="地址"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="AdminName"
                label="联系人"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="AdminPhone"
                label="电话"
                align="center"
              ></el-table-column>
              <el-table-column
                label="操作"
                width="150"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >查看</el-button>
                  <el-button
                    @click="editClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >编辑</el-button>
                  <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </zj-layout-main>
        </zj-layout-container>
      </zj-layout-main>
      <!-- 分页 -->
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
const utils = ZJApp.ZJUtils;
export default {
  name: "CompanyList",
  controller: "UI",
  action: "CompanyList",
  props: {
    fullPath: String,
    path: String,
    query: Object,
    hash: String,
    targetUrl: String,
    targetUri: Object,
    menu: Object,
  },
  data() {
    return {
      Status: 1, //1：:景区 2：娱乐 3：民宿 4：酒店 5：饭店 6：旅行社 7：购物 8：旅游汽车 9：停车场 10：农家乐 11：乡村旅游点 12：集散中心 13：旅游厕所 14：博物馆 15：图书馆 16：治安 17：投诉
      statusName: "景区基础信息",
      loading: true,
      loadingText: "加载中...",
      searching: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      CompanyType: "景区",
      companyName: "", //企业名称
      level: "", //等级
      typeOptions: [], //存放所有企业类型
      typeLevelDic: [], //存放所有等级
      options: [
        { ItemKey: "3A", Extend1: "3A" },
        { ItemKey: "4A", Extend1: "4A" },
        { ItemKey: "5A", Extend1: "5A" },
        { ItemKey: "其他", Extend1: "其他" },
      ],
      optionsScenic: [
        //景区
        { ItemKey: "3A", Extend1: "3A" },
        { ItemKey: "4A", Extend1: "4A" },
        { ItemKey: "5A", Extend1: "5A" },
        { ItemKey: "其他", Extend1: "其他" },
      ],
      optionsHotel: [
        //酒店 饭店
        { ItemKey: "3星", Extend1: "3星" },
        { ItemKey: "4星", Extend1: "4星" },
        { ItemKey: "5星", Extend1: "5星" },
        { ItemKey: "其他", Extend1: "其他" },
      ],
      warehouselist: [],
      warehousevalue: "",
      selectData: null,
      dialogOpts: {
        dialogTableVisible: false,
        rowlist: null,
        dialogTable2Visible: false,
        rowlist2: null,
      },
      materialTypedate: null,
      materialTypedate2: null,
      MaterialTypeDic: [],
    };
  },
  components: {},
  // 模板渲染前调用：初始化某些属性，再渲染成视图
  created: function () {
    this.basedatabind();
  },
  // 模板渲染后调用：在初始化页面后，对dom节点进行一些需要的操作
  mounted: function () {
    this.Status = parseFloat(this.$route.query.Status);
    this.$nextTick(() => {
      this.search();
    });
  },
  // watch：侦听器，监听数据的变化进行响应
  watch: {
    // 监听查询变化
    query(newV) {
      this.Status = parseFloat(newV.Status);
    },
    // 监听身份变化
    Status(newV) {
      this.Status = newV;
      this.getStatus();
    },
  },
  methods: {
    getStatus() {
      switch (this.Status) {
        case 1:
          this.CompanyType = "景区";
          this.statusName = "景区基础信息";
          this.options = this.optionsScenic;
          break;
        case 2:
          this.CompanyType = "娱乐";
          this.statusName = "娱乐基础信息";
          break;
        case 3:
          this.CompanyType = "民宿";
          this.statusName = "民宿基础信息";
          break;
        case 4:
          this.CompanyType = "酒店";
          this.statusName = "酒店基础信息";
          this.options = this.optionsHotel;
          break;
        case 5:
          this.CompanyType = "饭店";
          this.statusName = "饭店基础信息";
          this.options = this.optionsHotel;
          break;
        case 6:
          this.CompanyType = "旅行社";
          this.statusName = "旅行社基础信息";
          break;
        case 7:
          this.CompanyType = "购物";
          this.statusName = "购物企业基础信息";
          break;
        case 8:
          this.CompanyType = "旅游汽车";
          this.statusName = "旅游汽车企业基础信息";
          break;
        case 10:
          this.CompanyType = "农家乐";
          this.statusName = "农家乐基础信息";
          break;
        case 11:
          this.CompanyType = "乡村旅游点";
          this.statusName = "乡村旅游点基础信息";
          this.options = this.optionsScenic;
          break;
        case 12:
          this.CompanyType = "集散中心";
          this.statusName = "集散中心基础信息";
          break;
        case 13:
          this.CompanyType = "旅游厕所";
          this.statusName = "旅游厕所基础信息";
          break;
        case 14:
          this.CompanyType = "博物馆";
          this.statusName = "博物馆基础信息";
          this.options = this.optionsHotel;
          break;
        case 15:
          this.CompanyType = "图书馆";
          this.statusName = "图书馆基础信息";
          this.options = this.optionsHotel;
          break;
        case 16:
          this.CompanyType = "治安";
          this.statusName = "治安基础信息";
          this.options = this.optionsHotel;
          break;
        case 17:
          this.CompanyType = "投诉";
          this.statusName = "投诉基础信息";
          this.options = this.optionsHotel;
          break;
        default:
          break;
      }
      // 回调：dom改变之后调用
      this.$nextTick(() => {
        this.search();
      });
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    //基础数据绑定 所属单位
    basedatabind() {
      this.loading = true;
      this.loadingText = "加载中...";
      utils
        .waitAll([this.config.getUValue("cyjc:cy", "")])
        .then((r) => {
          const eventlevelconf = r[0];
          this.typeOptions = eventlevelconf.JValue;
          for (let i = 0; i < this.typeOptions.length; i++) {
            let item = this.typeOptions[i];
            this.typeLevelDic[item.ItemKey] = item.Extend1;
          }
        })
        .catch((e) => {
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
      this.dialogOpts.rowlist = val;
      this.dialogOpts.rowlist2 = val;
      this.materialTypedate = this.MaterialTypeDic;
      this.materialTypedate2 = this.MaterialTypeDic;
    },
    search() {
      let searchInfo = {
        Name: this.companyName,
        Level: this.level,
        CompanyType: this.CompanyType,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
      };
      this.searching = true;
      new MyApis.TbTourCompanyApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          this.searching = false;
        })
        .catch((e) => {
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.searching = false;
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },

    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    clearsearch() {
      this.companyName = "";
      this.level = "";
    },

    //编辑按钮
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/IndustrialMonitoring/UI/CompanyAdd",
        query: {
          CompanyType: this.CompanyType,
          status: this.Status,
          InfoId: row.ID,
          type: "edit",
        },
      });
    },
    //查看详细
    handleClick(index, row) {
      this.$router.push({
        path: "/plugin/IndustrialMonitoring/UI/CompanyAdd",
        // name: 'mallList',
        query: {
          CompanyType: this.CompanyType,
          status: this.Status,
          InfoId: row.ID,
          type: "look",
        },
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/IndustrialMonitoring/UI/CompanyAdd",
        query: {
          CompanyType: this.CompanyType,
          InfoId: "",
          type: "add",
          status: this.Status,
        },
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        this.loadingText = "删除中...";
        new MyApis.TbTourCompanyApi()
          .DelItem(row)
          .then((r) => {
            r = r.data.Data;
            if (r) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            this.logInfo.ActionName = this.CompanyType + "基础信息删除";
            this.logInfo.LogMessage = r
              ? this.CompanyType + "基础信息删除成功"
              : this.CompanyType + "基础信息删除失败";
            this.logInfo.ModuleName = "产业基础信息";
            this.logInfo.PageName = this.CompanyType + "基础信息";
            this.addOperationLog();
            this.loading = false;
            this.search();
          })
          .catch((e) => {
            this.errmsg(e.RspMsg ? e.RspMsg : "删除失败！");
            this.loading = false;
          });
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
<style lang="css" scoped>
.table-default /deep/.el-table__body-wrapper {
  height: calc(100% - 44px) !important;
}
</style>

